export const getHeaders = () => {
  const token = localStorage.getItem('token');

  return {
    accessToken: token,
    Authorization: 'Basic ' + btoa(`${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`),
  }
}